<script setup lang="ts">
import { computed } from 'vue';

interface StepItemBlok {
    _uid: string;
    /** Plan / Storyblok schema */
    number?: string;
    title: string;
    description: string;
    /** Legacy */
    step_label?: string;
}

const props = defineProps<{ blok: StepItemBlok }>();

const stepNumber = computed(() => props.blok.number ?? props.blok.step_label ?? '');
</script>

<template>
    <div v-editable="blok" class="flex flex-col gap-4 text-center md:text-left">
        <div
            class="mx-auto flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#F5A77D] text-xl font-bold text-white md:mx-0"
        >
            {{ stepNumber }}
        </div>
        <div class="flex flex-col gap-2">
            <h3 class="text-xl font-semibold text-[#004646] xl:text-2xl">{{ blok.title }}</h3>
            <p class="text-base font-normal text-[#393734] xl:text-xl xl:leading-[30px]">
                {{ blok.description }}
            </p>
        </div>
    </div>
</template>
